export default {
    //TEXTO DE MENSAGENS E TÍTULOS
    m1: 'Por favor identifique-se para prosseguir com sua inscrição.',
    m2: 'Nos ambientes de teste não é possível autenticar com E-mail ou Conta da Rede UniCeub.',
    m3: 'Ambiente de teste',
    m4: 'Identificar participante',
    m5: 'Este ambiente é destinado somente a teste. Nenhuma informação utilizada nesse ambiente será refletida na produção.',
    m6: 'Ocorreu um erro ao carregar a página',
    m7: 'Evento não identificado',
    m8: 'É necessário informar o código para recuperar o Evento e suas atividades.',
    m9: 'Nenhuma atividade encontrada.',
    m10: 'Fim das atividades',
    m11: 'Todas as atividades  desse evento já estão sendo exibidas.',
    m12: 'Localizando mais atividades, aguarde...',
    m13: 'Sem inscrições',
    m14: 'Você não se inscreveu em nenhum evento.',
    m15: 'Estamos quase lá!',
    m16: 'Sem atividades para avaliar.',
    m17: 'Antes de iniciar o download do seu certificado responda à nossa pesquisa:',
    m18: 'Em uma escala de 0 a 10 quanto você recomendaria a(s) atividade(s) para outros interessados?',
    m19: 'Aguarde...',
    m20: 'O download do seu crachá irá começar em alguns segundos.',
    m21: 'Ocorreu um erro ao recuperar o seu crachá.',
    m22:'Ocorreu um erro ao recuperar o seu comprovante.',
    m23:'Você ainda não selecionou nenhuma atividade. Deseja realmente sair?',
    m24: 'Parabéns!',
    m25:'Você agora é participante do evento!',
    m26:'Ocorreu um erro ao continuar.',
    m27:'O participante não foi encontrado.',
    m28:'Este evento está fora do período de inscrições.',
    m29:'Utilize a opção "Visualizar Evento".',
    m30:'Bem vindo!',
    m31:'É bom tê-lo de volta.',
    m32:'Você não está inscrito no evento portanto não é possível baixar seu certificado.',
    m33:'Dados Pessoais',
    m34:'Atividade selecionada com sucesso!',
    m35:'Ocorreu um erro ao selecionar sua atividade.',
    m36:'Ops!',
    m37:'Não foi possível remover a atividade.',
    m38:'Certificado',
    m39:'Ocorreu um erro ao recuperar os eventos para avaliação.',
    m40:'O download do seu certificado irá começar em alguns segundos.',
    m50:'Ocorreu um erro ao recuperar o certificado.',
    m51:'Evento não identificado',
    m52:'Participante',
    m53:'Atenção!',
    m54:'Você ainda não selecionou nenhuma atividade.',
    m55:'Filtros',
    m56:'Ordenação',
    m57:'Presença não marcada',
    m58:'Identificação realizada com sucesso.',
    m59:'Atividade excluída com sucesso!',

    //TEXTO DE PLACEHOLDERS
    p1: 'Tipo de Participante',
    p2: 'RA ou E-mail ou CPF',
    p3: 'Matrícula ou E-mail ou CPF',
    p4: 'Senha',
    p5: 'CPF',
    p6: 'E-mail',
    p7:'Data (Crescente)',
    p8:'Data (Decrescente)',
    p9:'Nome da Atividade',
    p10:'Eventos em Andamento',
    p11:'Atividades de hoje',
    p12:'Todas as atividades',
    p13:'Atividades inscritas',
    p14:'Pesquisar atividade por nome, local ou curso...',
    p15:'Nome *',
    p16:'CPF *',
    p17:'Telefone Celular *',
    p18:'E-mail *',
    p19:'Aluno',
    p20:'Funcionário',
    p21:'Público Externo',


    //TEXTO DE BOTÕES
    b1: 'Limpar',
    b2: 'Visualizar Evento',
    b3: 'Identificar participante',
    b4:'Excluir',
    b5:'Selecione',
    b6:'Choque de Horário',
    b7:'Atividade Realizada',
    b8:'Sem Vagas',
    b9:'Presença Marcada',
    b10:'Inscrito',
    b11:'Inscrições Encerradas',
    b12:'inscrição disponível',
    b13:'atividades hoje',
    b14:'atividades com vagas disponíveis',
    b15:'Baixar Certificado',
    b16:'Comprovante',
    b17:'Crachá',
    b18:'Certificado',
    b19:'Enviar Avaliação',
    b20:'Evento Avaliado',
    b21:'Confirmar',
    b22:'Limpar',
    b23:'Voltar',
    b24:'Atividade Cancelada'

}


// WEBPACK FOOTER //
// ./src/Mensagens.js